import script from "./main-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./main-card.vue?vue&type=script&setup=true&lang=ts"

import "./main-card.vue?vue&type=style&index=0&id=639f77ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639f77ee"]])

export default __exports__